import 'dayjs/locale/de';
import PropTypes from 'prop-types';
import Box from '@mui/system/Box';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import Collapse from '@mui/material/Collapse';
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import shadows from '@mui/material/styles/shadows';
import * as Yup from 'yup';
import { InsertDriveFile } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Radio from '@mui/material/Radio';
import MenuItem from '@mui/material/MenuItem';
import React, { useMemo, useState, useEffect, useRef } from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { fileSizeInMB } from '../../../../services/utils/pdf-byte';
import LightTooltip from './LightTooltip';
import dayjs from 'dayjs';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RadioGroup } from 'formik-mui';
import { useTranslation } from 'react-i18next';
import {
  getBillingCycleOptions,
  getBillingCycleToSend,
  getInitialBillingCycle,
  isBillingCycleEditable,
  isBillingCycleVisible,
} from '../../../../services/utils/billingCycle';
import { getBillingCycleData } from '../../../../services/utils/translations-constants';
/**
 * @param {PropTypes.InferProps<UserCreationFormContract.propTypes>} props
 */
const UserCreationFormContract = ({
  payload,
  setPayload,
  confirmPayload,
  submit,
  setSubmit,
  setCanNext,
  editFlag,
  pdfFlag,
  payloadOne,
}) => {
  const { t } = useTranslation();
  const [isAccessRequested, setIsAccessRequested] = useState(
    payload?.contractStatus === 'ACCESS_REQUESTED' || false
  );
  const contractUrl = `${window._env_.REACT_APP_CONTRACT_MANGEMENT_API}/pdf/${payload?.contractKey}?verificationId=${payload?.contractId}`;
  const isPdfWithBilling = payload?.contractInfo.contractPDF;
  const [contract, setContract] = useState(null);
  const authType = 'APP';
  const [tooltipOpen, setTooltipOpen] = useState('');
  const [minStartDate, setMinStartDate] = useState('');
  const [minEndDate, setMinEndDate] = useState('');
  const [billingType, setBillingType] = useState('');
  const openEndDateTooltip = (name) => () => setEndDateTooltipOpen(name);
  const closeEndDateTooltip = () => setEndDateTooltipOpen('');
  const [endDateTooltipOpen, setEndDateTooltipOpen] = useState('');
  const userCreationFormContractRef = useRef();
  const [cpoPaymentPreference, setCpoPaymentPreference] = useState(null);

  useEffect(() => {
    let billingType = null;
    // first set the CpoPaymentPreference
    if (
      payloadOne?.cpoPaymentPreference?.length === 1 &&
      payloadOne?.cpoPaymentPreference[0] === 'NO_PAYMENT_METHOD'
    ) {
      setCpoPaymentPreference('NO_PAYMENT_METHOD');
    } else {
      setCpoPaymentPreference(payloadOne?.cpoPaymentPreference);
    }
    // then set the billingType
    if (payload?.billingType) {
      billingType = payload?.billingType;
    } else if (
      payloadOne?.cpoPaymentPreference?.length === 1 &&
      payloadOne?.cpoPaymentPreference[0] === 'NO_PAYMENT_METHOD'
    ) {
      billingType = 'NO_BILLING';
    } else if (
      payloadOne?.cpoPaymentPreference?.includes('BANK_TRANSFER') ||
      payloadOne?.cpoPaymentPreference?.includes('SEPA') ||
      payloadOne?.cpoPaymentPreference?.includes('STRIPE_SEPA')
    ) {
      billingType = 'WITH_BILLING';
    } else {
      billingType = 'NO_BILLING';
    }

    setBillingType(billingType);
  }, [payloadOne]);
  useEffect(() => {
    if (submit > 0) document.getElementById('subTwo').click();
    setSubmit(0);
    let today = new Date();
    let yyyy = today.getFullYear();
    if (editFlag == true) {
      let dbDate = new Date(payload?.contractInfo?.startDate);
      if (today > dbDate && payload?.contractStatus === 'ACTIVE') {
        setMinStartDate(
          yyyy +
            dbDate.toLocaleString('en-US', { month: '2-digit' }) +
            dbDate.toLocaleString('en-US', { day: '2-digit' })
        );
      } else {
        setMinStartDate(
          yyyy +
            today.toLocaleString('en-US', { month: '2-digit' }) +
            today.toLocaleString('en-US', { day: '2-digit' })
        );
      }
    } else {
      setMinStartDate(
        yyyy +
          today.toLocaleString('en-US', { month: '2-digit' }) +
          today.toLocaleString('en-US', { day: '2-digit' })
      );
    }
    const date = new Date();
    const endDate = new Date(date.setDate(date.getDate() + 1));
    setMinEndDate(
      yyyy +
        endDate.toLocaleString('en-US', { month: '2-digit' }) +
        endDate.toLocaleString('en-US', { day: '2-digit' })
    );
  }, [submit, minStartDate]);

  const setEndDate = (value) => {
    if (value) {
      const date = new Date(value);
      const endDate = new Date(date.setDate(date.getDate() + 1));
      const yyyy = endDate.getFullYear();
      setMinEndDate(
        yyyy +
          endDate.toLocaleString('en-US', { month: '2-digit' }) +
          endDate.toLocaleString('en-US', { day: '2-digit' })
      );
    }
  };

  const isEdit = editFlag === true;
  const contractStatus = payload?.contractStatus;
  // the billing cycle can be chosen on creation and changed until the contract is active
  const billingCycleEditable = isBillingCycleEditable(isEdit, contractStatus);
  const { billingCycleMap } = getBillingCycleData(t);

  const contractInfo = payload?.contractInfo ?? {};
  const contractTaxRateFix = payload?.contractTaxRates?.contractTaxRateFix;

  const contractTaxRate =
    contractTaxRateFix !== undefined && contractTaxRateFix !== null
      ? contractTaxRateFix * 100
      : '';

  const shouldUseNoBilling =
    !cpoPaymentPreference || payload?.billingType === 'NO_BILLING';

  const getTariffValue = (field, withBilling) => {
    if (!withBilling && isEdit) {
      return '';
    }

    const fallback = withBilling && isEdit ? 0 : '';

    return contractInfo?.[field] ?? fallback;
  };

  const buildInitialValues = (withBilling) => ({
    billingType:
      payload?.billingType ?? (withBilling ? 'WITH_BILLING' : 'NO_BILLING'),
    authType: 'APP',
    contractPDF: '',
    fixTariff: getTariffValue('fixTariff', withBilling),
    varTariff: getTariffValue('varTariff', withBilling),
    fixTariffPerChargingRequest: contractInfo?.fixTariffPerChargingRequest ?? 0,
    onboardingFee: contractInfo?.onboardingFee ?? 0,
    startDate: contractInfo?.startDate ?? '',
    endDate: contractInfo?.endDate ?? '',
    contractTaxRate,
    billingCycle: getInitialBillingCycle(payload?.billingCycle),
  });

  const initialValues = buildInitialValues(!shouldUseNoBilling);

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        billingType: Yup.string().label(t('billingType')),
        billingCycle: Yup.string().label(t('LBLBillingCycle')),
        contractPDF: Yup.mixed().label(t('currentcontract')),
        fixTariffPerChargingRequest: Yup.mixed().label(
          t('fixTariffPerChargingRequest')
        ),
        onboardingFee: Yup.mixed().label(t('onboardingFee')),
        fixTariff:
          billingType === 'WITH_BILLING'
            ? payload?.contractStatus === 'ACTIVE'
              ? Yup.number().label(t('usagetarrif'))
              : Yup.number().required(t('usagereq')).label(t('usagetarrif'))
            : Yup.number().label(t('usagetarrif')),
        varTariff:
          billingType === 'WITH_BILLING'
            ? payload?.contractStatus === 'ACTIVE'
              ? Yup.number().label(t('chargintarif'))
              : Yup.number()
                  .required(t('electtarrifreq'))
                  .label(t('chargintarif'))
            : Yup.number().label(t('chargintarif')),

        startDate:
          payload?.contractStatus === 'ACTIVE'
            ? Yup.date().label(t('LBLStartDate'))
            : Yup.date().required(t('LBLReqCockpit')),
        endDate: Yup.date().when('startDate', {
          is: (startDate) => {
            return !startDate || startDate.length === 0;
          },
          then: () =>
            Yup.date()
              .min(Yup.ref('startDate'), t('LBLEDdgStart'))
              .label(t('LBLEndDate'))
              .nullable(),
          otherwise: () =>
            Yup.date()
              .min(Yup.ref('startDate'), t('LBLENdgStart'))
              .label(t('LBLEndDate'))
              .nullable(),
        }),
        contractTaxRate: Yup.mixed()
          .nullable()
          .test(
            'contractTaxRate-valid-number',
            t('contractTaxRateNumber'),
            (value) => {
              if (value === '' || value === null || value === undefined) {
                return true;
              }
              const stringValue = String(value).trim();
              if (stringValue === '') return false;
              if (!/^-?\d+(\.\d+)?$/.test(stringValue)) return false;
              return Number.isFinite(Number(stringValue));
            }
          )
          .test(
            'contractTaxRate-decimal-places',
            t('contractTaxRateDecimalPlaces'),
            (value) => {
              if (value === '' || value === null || value === undefined) {
                return true;
              }
              const stringValue = String(value).trim();
              if (stringValue === '') return true;
              return /^-?\d+(\.\d{1,2})?$/.test(stringValue);
            }
          )
          .test('contractTaxRate-range', t('contractTaxRateRange'), (value) => {
            if (value === '' || value === null || value === undefined) {
              return true;
            }
            const stringValue = String(value).trim();
            if (stringValue === '') return true;
            const num = Number(stringValue);
            if (!Number.isFinite(num)) return true;
            return num >= 0 && num <= 100;
          }),
      }),
    [billingType, authType]
  );

  /**
   * @method
   * @typedef {import("formik").FormikProps<typeof initialValues>} Props
   * @param {Props['setFieldError']} setFieldError
   * @param {Props['setFieldValue']} setFieldValue
   * @returns {(event: React.ChangeEvent<HTMLInputElement>) => void}
   */
  const handleBillingTypeChange =
    (handleChange, setFieldError, setFieldValue) => (event) => {
      setBillingType(event.target.value);
      handleChange(event);
    };
  const handleChooseFile = (setFieldError, setFieldValue) => (event) => {
    const file = event.target.files[0];

    if (!file) return setFieldValue('contractPDF', '');

    if (file.type !== 'application/pdf') {
      return setFieldError('contractPDF', t('pdfOnly'));
    }

    if (fileSizeInMB(file.size) > 3) {
      return setFieldError('contractPDF', t('3mb'));
    }

    setContract(file);
    setFieldValue('contractPDF', file.name);
  };

  /**
   * @method
   * @param {Props['values']} values
   * @param {Props['handleChange']} handleChange
   * @returns {(event: React.ChangeEvent<HTMLInputElement>) => void}
   */

  const openTooltip = (name) => () => setTooltipOpen(name);
  const closePdfTooltip = () => setTooltipOpen('');

  const closeTaxRateTooltip = () => setTooltipOpen('');

  // eslint-disable-next-line no-unused-vars
  const handleChooseFileBlur = (setFieldTouched) => (event) => {
    setFieldTouched('contractPDF', true, true);
  };

  /** @type {import("formik").FormikConfig<typeof initialValues>['onSubmit']} */
  const handleSubmit = (values, actions) => {
    const noBilling = billingType === 'NO_BILLING';
    const submittedBillingType =
      cpoPaymentPreference == 'NO_PAYMENT_METHOD'
        ? 'NO_BILLING'
        : values.billingType; // can be "WITH_BILLING" or "NO_BILLING"

    const payload = {
      billingType: submittedBillingType,
      // not sent when hidden or disabled, then the stored billing cycle is kept
      billingCycle: getBillingCycleToSend({
        isEdit,
        contractStatus,
        billingType: submittedBillingType,
        billingCycle: values.billingCycle,
      }),
      contractInfo: {
        contractPDF: contract || null,
        fixTariff: noBilling ? '' : Number(values.fixTariff || 0),
        varTariff: noBilling ? '' : Number(values.varTariff || 0),
        fixTariffPerChargingRequest: noBilling
          ? 0
          : Number(values.fixTariffPerChargingRequest),
        onboardingFee:
          values.onboardingFee === '' || values.onboardingFee === undefined
            ? 0
            : Number(values.onboardingFee),
        startDate: values.startDate,
        endDate: values.endDate === '' ? '' : values.endDate,
      },
      contractTaxRates: (() => {
        const raw = values.contractTaxRate;
        const trimmed =
          typeof raw === 'string' ? raw.trim() : raw;
        if (
          trimmed === '' ||
          trimmed === undefined ||
          trimmed === null
        ) {
          return { contractTaxRateFix: null, contractTaxRateVar: null };
        }
        const parsed = Number(trimmed);
        if (!Number.isFinite(parsed)) {
          return { contractTaxRateFix: null, contractTaxRateVar: null };
        }
        const rate = parsed / 100;
        const normalized = rate === 0 ? 0 : rate;
        return {
          contractTaxRateFix: normalized,
          contractTaxRateVar: normalized,
        };
      })(),
    };

    setPayload(payload);
    confirmPayload();
    actions.setSubmitting(false);
    actions.setTouched({}, false);
    actions.setErrors({});
    actions.setFieldError({});
    actions.setFieldTouched({}, false, false);
    actions.setFieldValue('contractPDF', values.contractPDF);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount={true}
      onSubmit={handleSubmit}
      innerRef={userCreationFormContractRef}
    >
      {({
        errors,
        touched,
        values,
        setFieldValue,
        setFieldError,
        setFieldTouched,
        handleChange,
        isSubmitting,
        isValid,
      }) => (
        <Form noValidate>
          <>
            {setCanNext(touched && isValid)}

            <Stack mb={5} direction="row" spacing={8}>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                width="100%"
              >
                <Field
                  disabled={isAccessRequested}
                  margin="none"
                  sx={{ width: '100%' }}
                  component={RadioGroup}
                  aria-labelledby="abrechnungsart-label"
                  name="billingType"
                  value={billingType}
                  onChange={handleBillingTypeChange(
                    handleChange,
                    setFieldError,
                    setFieldValue
                  )}
                >
                  <Typography
                    fontWeight={700}
                    variant="subtitle1"
                    id="abrechnungsart-label"
                  >
                    {t('billingType')}
                  </Typography>
                  <FormControlLabel
                    value="WITH_BILLING"
                    sx={{ width: 'fit-content' }}
                    control={
                      <Radio
                        disabled={
                          isSubmitting ||
                          !cpoPaymentPreference ||
                          cpoPaymentPreference == 'NO_PAYMENT_METHOD' ||
                          payload?.contractStatus === 'ACTIVE' ||
                          isAccessRequested
                        }
                      />
                    }
                    label={t('chargable')}
                    disabled={
                      isSubmitting ||
                      !cpoPaymentPreference ||
                      cpoPaymentPreference == 'NO_PAYMENT_METHOD' ||
                      payload?.contractStatus === 'ACTIVE' ||
                      isAccessRequested
                    }
                  />
                  <FormControlLabel
                    value="NO_BILLING"
                    sx={{ width: 'fit-content' }}
                    control={
                      <Radio
                        disabled={
                          isSubmitting ||
                          payload?.contractStatus === 'ACTIVE' ||
                          isAccessRequested
                        }
                      />
                    }
                    label={t('free')}
                    disabled={
                      isSubmitting ||
                      payload?.contractStatus === 'ACTIVE' ||
                      isAccessRequested
                    }
                  />
                </Field>

                {editFlag == true ? (
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="de"
                  >
                    <DatePicker
                      disabled={
                        payload?.contractStatus === 'ACTIVE' ||
                        isAccessRequested
                      }
                      label={t('LBLStartDate')}
                      minDate={dayjs(minStartDate)}
                      PaperProps={{ sx: { boxShadow: shadows[3] } }}
                      value={values.startDate}
                      id={'startDate'}
                      onChange={(newValue) => {
                        setEndDate(newValue);
                        setFieldValue(
                          'startDate',
                          newValue ? newValue.toDate() : ''
                        );
                      }}
                      renderInput={(params) => (
                        <Field
                          component={TextField}
                          {...params}
                          required={payload?.contractStatus != 'ACTIVE'}
                          name="startDate"
                          margin="none"
                          autoComplete="off"
                          helperText={touched.startDate && errors.startDate}
                          error={errors.startDate && touched.startDate}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: 'TT.MM.JJJJ',
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                ) : (
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="de"
                  >
                    <DatePicker
                      disabled={
                        payload?.contractStatus === 'ACTIVE' ||
                        isAccessRequested
                      }
                      label={t('LBLStartDate')}
                      minDate={dayjs(minStartDate)}
                      PaperProps={{ sx: { boxShadow: shadows[3] } }}
                      value={values.startDate}
                      id={'startDate'}
                      onChange={(newValue) => {
                        setEndDate(newValue);
                        setFieldValue(
                          'startDate',
                          newValue ? newValue.toDate() : ''
                        );
                      }}
                      renderInput={(params) => (
                        <Field
                          component={TextField}
                          {...params}
                          required={payload?.contractStatus != 'ACTIVE'}
                          name="startDate"
                          margin="none"
                          autoComplete="off"
                          helperText={touched.startDate && errors.startDate}
                          error={errors.startDate && touched.startDate}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: 'TT.MM.JJJJ',
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="de"
                >
                  <DatePicker
                    minDate={dayjs(minEndDate)}
                    PaperProps={{ sx: { boxShadow: shadows[3] } }}
                    label={t('LBLEndDate')}
                    value={values.endDate}
                    onChange={(newValue) => {
                      setFieldValue(
                        'endDate',
                        newValue ? newValue.toDate() : null
                      );
                    }}
                    renderInput={(params) => (
                      <Field
                        component={TextField}
                        {...params}
                        name="endDate"
                        margin="none"
                        autoComplete="off"
                        helperText={touched.endDate && errors.endDate}
                        error={errors.endDate && touched.endDate}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: 'TT.MM.JJJJ',
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
              <Stack
                direction="row"
                alignItems="flex-start"
                style={{ marginTop: '35px' }}
              >
                <LightTooltip
                  open={endDateTooltipOpen === 'endDateToolTip'}
                  onOpen={openEndDateTooltip('endDateToolTip')}
                  onClose={closeEndDateTooltip}
                  placement="top-start"
                  title={t('pleaseempty')}
                >
                  <InfoIcon
                    color="action"
                    fontSize="small"
                    sx={{
                      position: 'absolute',
                      display: 'flex',
                      ml: -6,
                      mt: 2,
                    }}
                  />
                </LightTooltip>
              </Stack>
            </Stack>
            {/* billing cycle, only for contracts with billing */}
            <Collapse
              in={isBillingCycleVisible(billingType)}
              mountOnEnter
              unmountOnExit
            >
              <Stack
                mb={5}
                direction="row"
                width="48.5%"
                alignItems="center"
                spacing={2}
              >
                <Field
                  component={TextField}
                  select
                  fullWidth
                  margin="none"
                  id="billingCycle"
                  name="billingCycle"
                  label={t('LBLBillingCycle')}
                  disabled={isSubmitting || !billingCycleEditable}
                >
                  {getBillingCycleOptions(values.billingCycle).map(
                    (billingCycle) => (
                      <MenuItem key={billingCycle} value={billingCycle}>
                        {billingCycleMap[billingCycle] || billingCycle}
                      </MenuItem>
                    )
                  )}
                </Field>
                {!billingCycleEditable && (
                  <LightTooltip
                    open={tooltipOpen === 'billingCycle'}
                    onOpen={openTooltip('billingCycle')}
                    onClose={closePdfTooltip}
                    placement="top-start"
                    title={t('LBLBillingCycleContactSupport')}
                  >
                    <InfoIcon
                      id="billingCycleInfo"
                      color="action"
                      fontSize="small"
                    />
                  </LightTooltip>
                )}
              </Stack>
            </Collapse>
            <Fade
              in={
                payload?.billingType === 'WITH_BILLING' &&
                values?.billingType === 'WITH_BILLING'
              }
            >
              {pdfFlag == true ? (
                <Stack mb={2} direction="row" alignItems="center" spacing={5}>
                  <Typography
                    fullWidth
                    align="left"
                    color={isPdfWithBilling && 'blue'}
                    fontWeight={500}
                  >
                    {t('currentcontract')}
                  </Typography>
                  <Typography
                    fullWidth
                    align="left"
                    color={isPdfWithBilling && 'blue'}
                    fontWeight="fontWeightRegular"
                    label={t('currentcontract')}
                  >
                    {
                      <IconButton
                        //disabled={payload?.contractStatus === 'ACTIVE'}
                        component={'a'}
                        target="_blank"
                        href={contractUrl}
                        color="primary"
                      >
                        <InsertDriveFile />
                      </IconButton>
                    }
                  </Typography>
                </Stack>
              ) : (
                <div></div>
              )}
            </Fade>
            <Stack direction="row" width="48.5%" spacing={8}>
              <Fade in={billingType === 'WITH_BILLING'}>
                <Box width="100%">
                  <LightTooltip
                    open={tooltipOpen === 'billingType'}
                    onOpen={openTooltip('billingType')}
                    onClose={closePdfTooltip}
                    placement="top-start"
                    title={t('3mb')}
                  >
                    <InfoIcon
                      color="action"
                      fontSize="small"
                      sx={{ position: 'absolute', ml: -6, mt: 2 }}
                    />
                  </LightTooltip>
                  <Field
                    //disabled={payload?.contractStatus === 'ACTIVE'}
                    error={Boolean(touched.contractPDF && errors.contractPDF)}
                    helperText={touched.contractPDF && errors.contractPDF}
                    inputProps={{ accept: 'application/pdf' }}
                    onBlur={handleChooseFileBlur(setFieldTouched)}
                    onChange={handleChooseFile(setFieldError, setFieldValue)}
                    fullWidth
                    type="file"
                    margin="none"
                    component={TextField}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Keine Datei ausgewählt"
                    id="nutzungs-und-ladestrom-vertrag"
                    name="contract"
                    label={t('currentcontract')}
                  />
                </Box>
              </Fade>
            </Stack>

            <Fade in={billingType === 'WITH_BILLING'}>
              <Stack mb={5} direction="row" spacing={10}>
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  sx={{
                    fontWeight: 'bold',
                    fontSize: 10,
                  }}
                >
                  {t('uploadconsent')}
                </Typography>
                <Box position="relative" width="70%">
                  {' '}
                </Box>
              </Stack>
            </Fade>

            <Collapse
              in={billingType === 'WITH_BILLING'}
              mountOnEnter
              unmountOnExit
            >
              <Stack mb={5} direction="row" spacing={8}>
                <Field
                  required={billingType === 'WITH_BILLING'}
                  fullWidth
                  component={TextField}
                  disabled={
                    payload?.contractStatus === 'ACTIVE' || isAccessRequested
                  }
                  id="nutzungstarif"
                  name="fixTariff"
                  margin="none"
                  type="number"
                  label={t('tarif')}
                  inputProps={{ min: 0, step: 0.0001 }}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">€/Monat</InputAdornment>
                    ),
                  }}
                />
                <Field
                  required={billingType === 'WITH_BILLING'}
                  disabled={
                    payload?.contractStatus === 'ACTIVE' || isAccessRequested
                  }
                  fullWidth
                  component={TextField}
                  id="ladestromtarif"
                  name="varTariff"
                  type="number"
                  label={t('chargintarif')}
                  inputProps={{ min: 0, step: 0.0001 }}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">€/kWh</InputAdornment>
                    ),
                  }}
                />
              </Stack>
              <Stack mb={5} direction="row" spacing={8}>
                <Field
                  fullWidth
                  component={TextField}
                  disabled={
                    payload?.contractStatus === 'ACTIVE' || isAccessRequested
                  }
                  id="onboardingFee"
                  name="onboardingFee"
                  margin="none"
                  type="number"
                  label={t('onboardingFee')}
                  inputProps={{ min: 0, step: 0.0001 }}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">€</InputAdornment>
                    ),
                  }}
                />
                <Field
                  fullWidth
                  component={TextField}
                  disabled={
                    payload?.contractStatus === 'ACTIVE' || isAccessRequested
                  }
                  id="fixTariffPerChargingRequest"
                  name="fixTariffPerChargingRequest"
                  type="number"
                  label={t('fixTariffPerChargingRequest')}
                  inputProps={{ min: 0, step: 0.0001 }}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {t('charginrequestUnit')}
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
              <Stack direction="row" width="48.5%" spacing={8}>
                <Box width="100%">
                  {! (payload?.contractStatus === 'ACTIVE' || 
                      (isAccessRequested && 
                        payload?.contractTaxRates?.contractTaxRateFix !== null &&
                      payload?.contractTaxRates?.contractTaxRateFix !== undefined)) ? (
                  <LightTooltip
                    open={tooltipOpen === 'taxRate'}
                    onOpen={openTooltip('taxRate')}
                    onClose={closeTaxRateTooltip}
                    placement="top-start"
                    title={t('taxRateTooltip', { taxRate: payloadOne?.operatorTaxRateFix * 100 })}
                  >
                    <InfoIcon
                      color="action"
                      fontSize="small"
                      sx={{ position: 'absolute', ml: -6, mt: 2 }}
                    />
                  </LightTooltip>
                  ) : null}
                  <Field
                    fullWidth
                    component={TextField}
                    disabled={
                      payload?.contractStatus === 'ACTIVE' || 
                      (isAccessRequested && 
                        payload?.contractTaxRates?.contractTaxRateFix !== null &&
                      payload?.contractTaxRates?.contractTaxRateFix !== undefined)
                    }
                    id="contractTaxRate"
                    name="contractTaxRate"
                    type="text"
                    label={t('contractTaxRate')}
                    inputProps={{
                      inputMode: 'decimal',
                      pattern: '^-?\\d+(\\.\\d{1,2})?$',
                    }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Stack>
            </Collapse>

            <Button sx={{ display: 'none' }} id="subTwo" type="submit"></Button>
          </>
        </Form>
      )}
    </Formik>
  );
};

UserCreationFormContract.propTypes = {
  payload: PropTypes.objectOf(PropTypes.any),
  setPayload: PropTypes.func.isRequired,
  confirmPayload: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default UserCreationFormContract;
